import "./pmwani.scss";
import Layout from "../../components/Layout";
import contact_map from "../../assets/images/contact_map.svg";
import pdoButton from "../../assets/images/pdoButton.svg"
import partnerButton from "../../assets/images/partnerButton.svg"
import faqLeft from "../../assets/images/faqLeft.svg"
import Accordion from "../../components/Accordion.js";
import map from "../../assets/images/map.svg";
import pmwanivector from "../../assets/images/PMWANI VECTOR (1).png"
// import coldMidImg from "../../assets/images/colMid.png";
import marketBanner from "../../assets/images/market_banner.png";
import marketBanner3 from "../../assets/images/market_banner3.svg";
import featuresList from "../../assets/images/featuresList.svg"
import tryButton from "../../assets/images/tryButton.svg"
import featuresvid from "../../assets/videos/OJI HUB/Features.mp4"
import modibanner from "../../assets/images/modibanner.png"
import cards from "../../assets/images/cards.svg";
import franchise_left from "../../assets/images/franchise_left.svg";
import franchisevid from "../../assets/videos/OJI HUB/Franchise Model - Section Animation.mp4"
import { FourthSection } from "../Home/Home";
import modirules from "../../assets/images/modirules.svg"
import franchise_rightpeople from "../../assets/images/franchise_rightpeople.svg";
import ContactForm from "../../components/ContactForm";
import coldMidImg from '../../assets/images/colMid.png';
import colmid1 from '../../assets/images/colmid1.svg'
import colmid2 from '../../assets/images/colmid2.svg'
import colmid3 from '../../assets/images/colmid3.svg'
import colmid4 from '../../assets/images/colmid4.svg'
import coldmidDef from '../../assets/images/colmidDef.svg'

import { useState } from "react";
const questionsAnswers = [
    {
      question: "What is PM-WANI?",
      answer:
        "You can invite up to 2 additional users on the Free plan. There is no limit on team members for the Premium plan.",
    },
    {
      question: "Who can become a PDO?",
      answer:
        "No more than 2GB. All files in your account must fit your allotted storage space.",
    },
    {
      question: "Advantage of becoming a PDO?",
      answer: `Click “Forgot password” from the login page or “Change password” from your profile page. A reset link will be emailed to you.`,
    },
    {
      question: "How do I become a PDO?",
      answer: `Yes! Send us a message and we’ll process your request no questions asked.`,
    },
    {
      question: "How much investment is required to become a PDO?",
      answer: `Chat and email support is available 24/7. Phone lines are open during normal business hours.`,
    },
    {
      question: "Why will someone buy WIFI coupons when already subscribed to mobile data (3g/4g/5g)",
      answer: `Chat and email support is available 24/7. Phone lines are open during normal business hours.`,
    },
    {
      question: "Can i use my home broadband connection as a backhul for my PDO",
      answer: `Chat and email support is available 24/7. Phone lines are open during normal business hours.`,
    },
    {
      question: "What is the income of PDO?",
      answer: `Chat and email support is available 24/7. Phone lines are open during normal business hours.`,
    },
  ];
const Pmwani = () => {
  const [coldMidImg, setColdMidImg] = useState(coldmidDef)

  const [active1, setActive1] = useState(false)
  const [active2, setActive2] = useState(false)
  const [active3, setActive3] = useState(false)
  const [active4, setActive4] = useState(false)
  const imgArray = [colmid1, colmid2, colmid3, colmid4]

  return (
    <Layout>
      <section className="pmwani">
        <div className="contact_wrapper">
          <div className="top">
            <div className="container pmwani_container">
            
              <h1>
              Unveiling the PM-WANI Scheme: Empowering India with
                <span> Public Wi-Fi Connectivity</span>
              </h1>

            </div>
          </div>
          <img src={pmwanivector} alt="" />

        </div>
      </section>
      
      <section className="digital_section">
      <div className="digital_wrapper">
        <div className="text_wrapper">
          <h1>
            Empowering <span>India's Digital Landscape</span>
            <br /> with PM-WANI
          </h1>
        </div>
        <div className="features_wrapper">
          <div className="col_left">
            <div
              className="textbox_wrapper"
              onMouseEnter={() => setColdMidImg(imgArray[0])}
            >
              <svg
                width="76"
                height="75"
                viewBox="0 0 76 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="75" height="75" rx="37.5" fill="#3F0099" />
                <path
                  d="M38 50C45.1797 50 51 44.1797 51 37C51 29.8203 45.1797 24 38 24C30.8203 24 25 29.8203 25 37C25 44.1797 30.8203 50 38 50Z"
                  fill="url(#paint0_linear_220_10794)"
                  fill-opacity="0.24"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.4"
                  d="M38 35C38.5304 35 39.0391 35.2107 39.4142 35.5858C39.7893 35.9609 40 36.4696 40 37C40 37.5304 39.7893 38.0391 39.4142 38.4142C39.0391 38.7893 38.5304 39 38 39C37.4696 39 36.9609 38.7893 36.5858 38.4142C36.2107 38.0391 36 37.5304 36 37C36 36.4696 36.2107 35.9609 36.5858 35.5858C36.9609 35.2107 37.4696 35 38 35Z"
                  fill="#030014"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M38 22C38.5304 22 39.0391 22.2107 39.4142 22.5858C39.7893 22.9609 40 23.4696 40 24C40 24.5304 39.7893 25.0391 39.4142 25.4142C39.0391 25.7893 38.5304 26 38 26C37.4696 26 36.9609 25.7893 36.5858 25.4142C36.2107 25.0391 36 24.5304 36 24C36 23.4696 36.2107 22.9609 36.5858 22.5858C36.9609 22.2107 37.4696 22 38 22ZM38 48C38.5304 48 39.0391 48.2107 39.4142 48.5858C39.7893 48.9609 40 49.4696 40 50C40 50.5304 39.7893 51.0391 39.4142 51.4142C39.0391 51.7893 38.5304 52 38 52C37.4696 52 36.9609 51.7893 36.5858 51.4142C36.2107 51.0391 36 50.5304 36 50C36 49.4696 36.2107 48.9609 36.5858 48.5858C36.9609 48.2107 37.4696 48 38 48ZM51 35C51.5304 35 52.0391 35.2107 52.4142 35.5858C52.7893 35.9609 53 36.4696 53 37C53 37.5304 52.7893 38.0391 52.4142 38.4142C52.0391 38.7893 51.5304 39 51 39C50.4696 39 49.9609 38.7893 49.5858 38.4142C49.2107 38.0391 49 37.5304 49 37C49 36.4696 49.2107 35.9609 49.5858 35.5858C49.9609 35.2107 50.4696 35 51 35ZM25 35C25.5304 35 26.0391 35.2107 26.4142 35.5858C26.7893 35.9609 27 36.4696 27 37C27 37.5304 26.7893 38.0391 26.4142 38.4142C26.0391 38.7893 25.5304 39 25 39C24.4696 39 23.9609 38.7893 23.5858 38.4142C23.2107 38.0391 23 37.5304 23 37C23 36.4696 23.2107 35.9609 23.5858 35.5858C23.9609 35.2107 24.4696 35 25 35Z"
                  fill="#030014"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_220_10794"
                    x1="38"
                    y1="24"
                    x2="38"
                    y2="50"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>

              <h3>PM-WANI Access Points</h3>
              <p>
                You only need a PM WANI complaint modem with internet from any
                ISP to get started
              </p>
            </div>
            <svg
              style={{
                position: 'relative',
                right: '-15%',
                zIndex: 0,
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="2"
              viewBox="0 0 375 2"
              fill="none"
            >
              <path
                d="M375 1L1.43051e-06 1"
                stroke="url(#paint0_linear_220_10781)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_220_10781"
                  x1="375"
                  y1="1.5"
                  x2="0"
                  y2="1.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3F0099" />
                  <stop offset="1" stop-color="#3F0099" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>

            <div
              className="textbox_wrapper"
              onMouseEnter={() => setColdMidImg(imgArray[1])}
            >
              <svg
                width="76"
                height="75"
                viewBox="0 0 76 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="75" height="75" rx="37.5" fill="#3F0099" />
                <path
                  d="M36 34.5V52.5L41 45.5H50L36 34.5Z"
                  fill="white"
                  stroke="white"
                  stroke-linejoin="round"
                />
                <path
                  d="M38 46.5C42.9706 46.5 47 42.4706 47 37.5C47 32.5294 42.9706 28.5 38 28.5C33.0294 28.5 29 32.5294 29 37.5C29 42.4706 33.0294 46.5 38 46.5Z"
                  fill="white"
                  fill-opacity="0.12"
                />
                <path
                  opacity="0.4"
                  d="M38 22.5V24.5"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M45.5 24.5098L44.5 26.2418M50.99 29.9998L49.258 30.9998M53 37.4998H51M26.742 43.9998L25.01 44.9998M25 37.4998H23"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.4"
                  d="M26.7418 30.9998L25.0098 29.9998M31.4998 26.2418L30.4998 24.5098"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <h3>Marketing Support</h3>
              <p>
                You can easily enable customers on flexible tariff plans at a
                per GB usage rate.
              </p>
            </div>
          </div>
          <div className="col_mid">
            <svg
              style={{
                position: 'relative',
                zIndex: 0,
                rotate: '90deg',
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="2"
              viewBox="0 0 375 2"
              fill="none"
            >
              <path
                d="M375 1L1.43051e-06 1"
                stroke="url(#paint0_linear_220_10781)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_220_10781"
                  x1="375"
                  y1="1.5"
                  x2="0"
                  y2="1.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3F0099" />
                  <stop offset="1" stop-color="#3F0099" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>

            <img
              src={coldMidImg}
              alt=""
              style={{
                position: 'relative',
                zIndex: '5',
              }}
            />
            <svg
              style={{
                position: 'relative',
                zIndex: 0,
                rotate: '-90deg',
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="2"
              viewBox="0 0 375 2"
              fill="none"
            >
              <path
                d="M375 1L1.43051e-06 1"
                stroke="url(#paint0_linear_220_10781)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_220_10781"
                  x1="375"
                  y1="1.5"
                  x2="0"
                  y2="1.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3F0099" />
                  <stop offset="1" stop-color="#3F0099" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="col_right">
            <div
              className="textbox_wrapper "
              onMouseEnter={() => setColdMidImg(imgArray[2])}
            >
              <svg
                width="76"
                height="75"
                viewBox="0 0 76 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="75" height="75" rx="37.5" fill="#3F0099" />
                <path
                  d="M46 31V25C46 24.2043 45.6839 23.4413 45.1213 22.8787C44.5587 22.3161 43.7956 22 43 22H27C26.2043 22 25.4413 22.3161 24.8787 22.8787C24.3161 23.4413 24 24.2043 24 25V49C24 49.7956 24.3161 50.5587 24.8787 51.1213C25.4413 51.6839 26.2043 52 27 52H43C43.7956 52 44.5587 51.6839 45.1213 51.1213C45.6839 50.5587 46 49.7956 46 49V42"
                  fill="url(#paint0_linear_220_10803)"
                  fill-opacity="0.24"
                />
                <path
                  d="M46 31V25C46 24.2043 45.6839 23.4413 45.1213 22.8787C44.5587 22.3161 43.7956 22 43 22H27C26.2043 22 25.4413 22.3161 24.8787 22.8787C24.3161 23.4413 24 24.2043 24 25V49C24 49.7956 24.3161 50.5587 24.8787 51.1213C25.4413 51.6839 26.2043 52 27 52H43C43.7956 52 44.5587 51.6839 45.1213 51.1213C45.6839 50.5587 46 49.7956 46 49V42"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M40 38V35H54V38H40Z"
                  fill="white"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.32"
                  d="M28 31V28H42V31H28Z"
                  fill="white"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M39 22L37 24H33L31 22"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_220_10803"
                    x1="35"
                    y1="22"
                    x2="35"
                    y2="52"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>

              <h3>PDOA Software</h3>
              <p>
                User validation & KYC are maintained in the Central registry of
                C-DoT.
              </p>
            </div>

            <svg
              style={{
                position: 'relative',
                right: '15%',
                zIndex: 0,
                rotate: '180deg',
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="2"
              viewBox="0 0 375 2"
              fill="none"
            >
              <path
                d="M375 1L1.43051e-06 1"
                stroke="url(#paint0_linear_220_10781)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_220_10781"
                  x1="375"
                  y1="1.5"
                  x2="0"
                  y2="1.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3F0099" />
                  <stop offset="1" stop-color="#3F0099" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>

            <div
              className="textbox_wrapper"
              onMouseEnter={() => setColdMidImg(imgArray[3])}
            >
              <svg
                width="76"
                height="75"
                viewBox="0 0 76 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="75" height="75" rx="37.5" fill="#3F0099" />
                <g clip-path="url(#clip0_220_10827)">
                  <path
                    d="M56.7001 41.2004H51.1875C50.1859 37.0852 47.7866 33.4453 44.3995 30.9025C44.6294 30.6831 44.8019 30.4107 44.9018 30.1091C45.0017 29.8075 45.026 29.486 44.9725 29.1728C44.919 28.8596 44.7894 28.5643 44.5951 28.3129C44.4008 28.0616 44.1477 27.8618 43.8581 27.7311L45.5481 21.7635C45.6589 21.3772 45.6786 20.9705 45.6056 20.5753C45.5326 20.1802 45.3689 19.8073 45.1273 19.4862C44.8857 19.1651 44.5729 18.9044 44.2135 18.7246C43.8541 18.5449 43.4578 18.451 43.056 18.4504H41.8801C41.5382 17.8564 41.0457 17.3629 40.4523 17.0198C39.8589 16.6767 39.1856 16.4961 38.5001 16.4961C37.8147 16.4961 37.1414 16.6767 36.548 17.0198C35.9546 17.3629 35.4621 17.8564 35.1201 18.4504H33.9436C33.5422 18.4512 33.1464 18.5451 32.7874 18.7247C32.4284 18.9043 32.116 19.1647 31.8746 19.4855C31.6332 19.8062 31.4695 20.1786 31.3963 20.5733C31.3231 20.968 31.3425 21.3743 31.4528 21.7602L33.1428 27.7311C32.8531 27.8618 32.5999 28.0617 32.4055 28.3133C32.2111 28.5648 32.0816 28.8603 32.0282 29.1737C31.9749 29.487 31.9994 29.8087 32.0995 30.1104C32.1997 30.4121 32.3725 30.6846 32.6027 30.9038C29.2237 33.4541 26.8257 37.0901 25.8121 41.2004H20.9501C20.573 41.1988 20.2035 41.307 19.8869 41.5118C19.5702 41.7167 19.3201 42.0094 19.167 42.3541C19.014 42.6988 18.9647 43.0806 19.0251 43.4529C19.0854 43.8252 19.253 44.1718 19.5071 44.4504C19.1811 44.8049 19.0001 45.2689 19.0001 45.7504C19.0001 46.232 19.1811 46.696 19.5071 47.0504C19.3155 47.2596 19.1723 47.5084 19.0877 47.7791C19.0031 48.0499 18.9792 48.3359 19.0177 48.6169C19.0562 48.898 19.1561 49.1671 19.3103 49.4051C19.4646 49.6432 19.6694 49.8443 19.9101 49.9943C19.7396 50.2841 19.6496 50.6142 19.6496 50.9504C19.6496 51.2867 19.7396 51.6168 19.9101 51.9066C19.5524 52.1314 19.2775 52.4666 19.127 52.8615C18.9766 53.2563 18.9588 53.6894 19.0762 54.0953C19.1937 54.5012 19.4401 54.8579 19.7781 55.1113C20.1162 55.3648 20.5276 55.5014 20.9501 55.5004H31.3501C31.709 55.4992 32.0605 55.3988 32.3657 55.2102C32.671 55.0216 32.9181 54.7522 33.0798 54.4318C34.8001 55.1363 36.6411 55.4993 38.5001 55.5004H56.7001C57.0449 55.5004 57.3756 55.3635 57.6194 55.1197C57.8632 54.8759 58.0001 54.5452 58.0001 54.2004V42.5004C58.0001 42.1557 57.8632 41.825 57.6194 41.5812C57.3756 41.3374 57.0449 41.2004 56.7001 41.2004ZM56.7001 44.3581C56.2532 44.2419 55.8453 44.0084 55.5187 43.6818C55.1922 43.3553 54.9587 42.9474 54.8424 42.5004H56.7001V44.3581ZM33.9501 30.1504C33.7777 30.1504 33.6124 30.082 33.4905 29.9601C33.3686 29.8382 33.3001 29.6728 33.3001 29.5004C33.3001 29.328 33.3686 29.1627 33.4905 29.0408C33.6124 28.9189 33.7777 28.8504 33.9501 28.8504H43.0501C43.2225 28.8504 43.3879 28.9189 43.5098 29.0408C43.6317 29.1627 43.7001 29.328 43.7001 29.5004C43.7001 29.6728 43.6317 29.8382 43.5098 29.9601C43.3879 30.082 43.2225 30.1504 43.0501 30.1504H33.9501ZM32.914 20.2665C33.0333 20.1061 33.1885 19.9759 33.3672 19.8863C33.5459 19.7966 33.7431 19.7501 33.943 19.7504H34.658C34.6207 19.9651 34.6013 20.1825 34.6001 20.4004V23.0004C34.6001 23.1728 34.6686 23.3382 34.7905 23.4601C34.9124 23.582 35.0777 23.6504 35.2501 23.6504C35.4225 23.6504 35.5879 23.582 35.7098 23.4601C35.8317 23.3382 35.9001 23.1728 35.9001 23.0004V20.4004C35.899 20.0425 35.9725 19.6883 36.1159 19.3604C36.3181 18.8964 36.6514 18.5015 37.0748 18.2241C37.4982 17.9468 37.9933 17.799 38.4995 17.799C39.0056 17.799 39.5008 17.9468 39.9242 18.2241C40.3476 18.5015 40.6808 18.8964 40.883 19.3604C41.0269 19.6882 41.1008 20.0424 41.1001 20.4004V23.0004C41.1001 23.1728 41.1686 23.3382 41.2905 23.4601C41.4124 23.582 41.5777 23.6504 41.7501 23.6504C41.9225 23.6504 42.0879 23.582 42.2098 23.4601C42.3317 23.3382 42.4001 23.1728 42.4001 23.0004V20.4004C42.3987 20.1825 42.3792 19.9651 42.3416 19.7504H43.0566C43.2569 19.752 43.4541 19.7998 43.6329 19.8901C43.8117 19.9804 43.9671 20.1109 44.0872 20.2712C44.2072 20.4315 44.2886 20.6174 44.325 20.8144C44.3614 21.0113 44.3517 21.214 44.2968 21.4066L42.5587 27.5504H34.4415L32.7028 21.4034C32.6467 21.2106 32.6366 21.0073 32.6733 20.8099C32.71 20.6124 32.7925 20.4263 32.914 20.2665ZM20.9501 42.5004H31.3501C31.5225 42.5004 31.6879 42.5689 31.8098 42.6908C31.9317 42.8127 32.0001 42.978 32.0001 43.1504C32.0001 43.3228 31.9317 43.4882 31.8098 43.6101C31.6879 43.732 31.5225 43.8004 31.3501 43.8004H20.9501C20.7777 43.8004 20.6124 43.732 20.4905 43.6101C20.3686 43.4882 20.3001 43.3228 20.3001 43.1504C20.3001 42.978 20.3686 42.8127 20.4905 42.6908C20.6124 42.5689 20.7777 42.5004 20.9501 42.5004ZM20.9501 50.9504C20.9501 50.778 21.0186 50.6127 21.1405 50.4908C21.2624 50.3689 21.4277 50.3004 21.6001 50.3004H32.0001C32.1725 50.3004 32.3379 50.3689 32.4598 50.4908C32.5817 50.6127 32.6501 50.778 32.6501 50.9504C32.6501 51.1228 32.5817 51.2882 32.4598 51.4101C32.3379 51.532 32.1725 51.6004 32.0001 51.6004H21.6001C21.4277 51.6004 21.2624 51.532 21.1405 51.4101C21.0186 51.2882 20.9501 51.1228 20.9501 50.9504ZM20.9501 49.0004C20.7777 49.0004 20.6124 48.932 20.4905 48.8101C20.3686 48.6882 20.3001 48.5228 20.3001 48.3504C20.3001 48.178 20.3686 48.0127 20.4905 47.8908C20.6124 47.7689 20.7777 47.7004 20.9501 47.7004H31.3501C31.5225 47.7004 31.6879 47.7689 31.8098 47.8908C31.9317 48.0127 32.0001 48.178 32.0001 48.3504C32.0001 48.5228 31.9317 48.6882 31.8098 48.8101C31.6879 48.932 31.5225 49.0004 31.3501 49.0004H20.9501ZM20.3001 45.7504C20.3001 45.578 20.3686 45.4127 20.4905 45.2908C20.6124 45.1689 20.7777 45.1004 20.9501 45.1004H31.3501C31.5225 45.1004 31.6879 45.1689 31.8098 45.2908C31.9317 45.4127 32.0001 45.578 32.0001 45.7504C32.0001 45.9228 31.9317 46.0882 31.8098 46.2101C31.6879 46.332 31.5225 46.4004 31.3501 46.4004H20.9501C20.7777 46.4004 20.6124 46.332 20.4905 46.2101C20.3686 46.0882 20.3001 45.9228 20.3001 45.7504ZM31.3501 54.2004H20.9501C20.7777 54.2004 20.6124 54.132 20.4905 54.0101C20.3686 53.8882 20.3001 53.7228 20.3001 53.5504C20.3001 53.378 20.3686 53.2127 20.4905 53.0908C20.6124 52.9689 20.7777 52.9004 20.9501 52.9004H31.3501C31.5225 52.9004 31.6879 52.9689 31.8098 53.0908C31.9317 53.2127 32.0001 53.378 32.0001 53.5504C32.0001 53.7228 31.9317 53.8882 31.8098 54.0101C31.6879 54.132 31.5225 54.2004 31.3501 54.2004ZM33.2351 53.0798C33.1922 52.91 33.1267 52.7466 33.0401 52.5943C33.3188 52.42 33.5486 52.1776 33.708 51.8901C33.8673 51.6025 33.9508 51.2792 33.9508 50.9504C33.9508 50.6217 33.8673 50.2984 33.708 50.0108C33.5486 49.7232 33.3188 49.4809 33.0401 49.3066C33.2464 48.9538 33.3337 48.544 33.2893 48.1377C33.2448 47.7315 33.0709 47.3503 32.7931 47.0504C33.1192 46.696 33.3002 46.232 33.3002 45.7504C33.3002 45.2689 33.1192 44.8049 32.7931 44.4504C33.0473 44.1718 33.2148 43.8252 33.2752 43.4529C33.3356 43.0806 33.2863 42.6988 33.1332 42.3541C32.9802 42.0094 32.7301 41.7167 32.4134 41.5118C32.0968 41.307 31.7273 41.1988 31.3501 41.2004H27.1427C28.1034 37.3732 30.9913 33.3179 34.1354 31.4504H42.8642C46.8539 33.8151 50.2001 39.4259 50.2001 43.8004C50.2001 49.5347 44.9514 54.2004 38.5001 54.2004C36.6862 54.1986 34.8927 53.8168 33.2351 53.0798ZM51.5001 43.8004C51.4962 43.3657 51.4665 42.9316 51.4111 42.5004H53.5086C53.6448 43.2973 54.025 44.0323 54.5966 44.6039C55.1683 45.1756 55.9033 45.5557 56.7001 45.6919V51.0089C55.9033 51.1451 55.1683 51.5253 54.5966 52.0969C54.025 52.6686 53.6448 53.4036 53.5086 54.2004H44.4288C48.6213 52.2563 51.5001 48.329 51.5001 43.8004ZM54.8424 54.2004C54.9587 53.7535 55.1922 53.3456 55.5187 53.019C55.8453 52.6925 56.2532 52.459 56.7001 52.3427V54.2004H54.8424Z"
                    fill="white"
                  />
                  <path
                    d="M54.0999 50.3004C54.4856 50.3004 54.8626 50.186 55.1833 49.9718C55.5039 49.7575 55.7539 49.4529 55.9015 49.0966C56.0491 48.7403 56.0877 48.3482 56.0124 47.97C55.9372 47.5917 55.7515 47.2442 55.4788 46.9715C55.206 46.6988 54.8586 46.5131 54.4803 46.4379C54.1021 46.3626 53.71 46.4012 53.3537 46.5488C52.9974 46.6964 52.6928 46.9464 52.4785 47.267C52.2643 47.5877 52.1499 47.9647 52.1499 48.3504C52.1499 48.8676 52.3553 49.3636 52.721 49.7292C53.0867 50.0949 53.5827 50.3004 54.0999 50.3004ZM54.0999 47.7004C54.2285 47.7004 54.3541 47.7385 54.461 47.8099C54.5679 47.8814 54.6512 47.9829 54.7004 48.1016C54.7496 48.2204 54.7625 48.3511 54.7374 48.4772C54.7123 48.6033 54.6504 48.7191 54.5595 48.81C54.4686 48.9009 54.3528 48.9628 54.2267 48.9879C54.1006 49.013 53.9699 49.0001 53.8512 48.9509C53.7324 48.9017 53.6309 48.8184 53.5594 48.7115C53.488 48.6046 53.4499 48.4789 53.4499 48.3504C53.4499 48.178 53.5184 48.0127 53.6403 47.8908C53.7622 47.7689 53.9275 47.7004 54.0999 47.7004Z"
                    fill="white"
                  />
                  <path
                    d="M40.4498 39.9C40.4498 40.0724 40.5183 40.2377 40.6402 40.3596C40.7621 40.4815 40.9274 40.55 41.0998 40.55C41.2722 40.55 41.4376 40.4815 41.5595 40.3596C41.6814 40.2377 41.7498 40.0724 41.7498 39.9C41.7489 39.1511 41.4898 38.4254 41.0162 37.8452C40.5426 37.265 39.8834 36.8659 39.1498 36.715V36.65C39.1498 36.4776 39.0814 36.3123 38.9595 36.1904C38.8376 36.0685 38.6722 36 38.4998 36C38.3274 36 38.1621 36.0685 38.0402 36.1904C37.9183 36.3123 37.8498 36.4776 37.8498 36.65V36.715C37.1152 36.8642 36.4546 37.2628 35.9802 37.8432C35.5058 38.4237 35.2466 39.1503 35.2466 39.9C35.2466 40.6497 35.5058 41.3763 35.9802 41.9568C36.4546 42.5372 37.1152 42.9358 37.8498 43.085V46.9311C37.4708 46.7971 37.1425 46.5492 36.9098 46.2214C36.6771 45.8937 36.5514 45.502 36.5498 45.1C36.5498 44.9276 36.4814 44.7623 36.3595 44.6404C36.2376 44.5185 36.0722 44.45 35.8998 44.45C35.7274 44.45 35.5621 44.5185 35.4402 44.6404C35.3183 44.7623 35.2498 44.9276 35.2498 45.1C35.2508 45.8489 35.5099 46.5746 35.9835 47.1548C36.4571 47.735 37.1163 48.1341 37.8498 48.285V48.35C37.8498 48.5224 37.9183 48.6877 38.0402 48.8096C38.1621 48.9315 38.3274 49 38.4998 49C38.6722 49 38.8376 48.9315 38.9595 48.8096C39.0814 48.6877 39.1498 48.5224 39.1498 48.35V48.285C39.8845 48.1358 40.545 47.7372 41.0195 47.1568C41.4939 46.5763 41.7531 45.8497 41.7531 45.1C41.7531 44.3503 41.4939 43.6237 41.0195 43.0432C40.545 42.4628 39.8845 42.0642 39.1498 41.915V38.0696C39.5287 38.2036 39.857 38.4513 40.0897 38.7789C40.3224 39.1066 40.4482 39.4981 40.4498 39.9ZM36.5498 39.9C36.5515 39.4981 36.6773 39.1066 36.91 38.7789C37.1427 38.4513 37.4709 38.2036 37.8498 38.0696V41.7304C37.4709 41.5964 37.1427 41.3487 36.91 41.0211C36.6773 40.6934 36.5515 40.3019 36.5498 39.9ZM40.4498 45.1C40.4482 45.5019 40.3224 45.8934 40.0897 46.2211C39.857 46.5487 39.5287 46.7964 39.1498 46.9304V43.2696C39.5287 43.4036 39.857 43.6513 40.0897 43.9789C40.3224 44.3066 40.4482 44.6981 40.4498 45.1Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_220_10827">
                    <rect
                      width="39"
                      height="39"
                      fill="white"
                      transform="translate(19 16.5)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <h3>Revenue opportunity</h3>
              <p>
                You can earn extra income and create employment opportunities
                for small and medium entrepreneurs.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="market_banner">
        <img src={marketBanner3} alt="" />
      </div>
    </section>
      <section className="pmwani_feature">
      <h1> Merits of PM-WANI</h1>
        <div className="features_wrapper  ">
            <div className="left">
                <img src={modirules} alt="" />
               
                   
            </div>
            <div className="right">
           <img src={modibanner} alt="" />
            </div>
          
        </div>
        <div className="button_wrapper">
        <button className="contactBtn">Contact Us: 8888760864</button>
        <button className="pdo_btn">
              Become a PDO
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9998 40.3337C30.1251 40.3337 38.3332 32.1255 38.3332 22.0003C38.3332 11.8751 30.1251 3.66699 19.9998 3.66699C9.87462 3.66699 1.6665 11.8751 1.6665 22.0003C1.6665 32.1255 9.87462 40.3337 19.9998 40.3337Z"
                  fill="white"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 27L25 21L20 15"
                  stroke="#3F0099"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            </div>
      </section>
      <section className="join_section pmwani_join">
        <div className="join_wrapper">
          <div className="text_wrapper">
            <h1>
              How to join <span>OJI as a PDO</span>
            </h1>

            <p>
              Joining OJI as a PDO is easy and hassle-free. <br /> All you need
              to do is{" "}
            </p>
          </div>
          <div className="cards_wrapper">
            <img src={cards} alt="" />
          </div>
        </div>
        {/* <div className="franchise_model">
          <img src={franchisModel} alt="" />
          <button>
            <img src={partnerButton} alt="" />
          </button>
        </div> */}
        <div className="franchise_prewrapper">
          <div className="franchise_wrapper">
              <div className="left">
                  <img src={franchise_left} className="franchise_left_img" alt="" />
                  <button><img src={partnerButton} alt="" /></button>
              </div>
              <div className="right">
              <video muted playsInline loop autoPlay>
                <source src={franchisevid} type="video/mp4" />
              </video>
                  {/* <img src={franchise_rightpeople} className="franchise_rightpeople" alt="" /> */}
              </div>
          </div>
        </div>
      </section>
      <section className="faq">
        <div className="faq_wrapper">
       
          <div className="left">
          <h1>FAQ</h1>

            <img src={faqLeft} alt="" />
          </div>
          <div className="right">
            <div className="container">
            <Accordion questionsAnswers={questionsAnswers} />
            </div>
          </div>

        </div>
      </section>
        <ContactForm/>
    </Layout>
  );
};

export default Pmwani;
